import {
  ProcessCellForExportParams,
  ValueFormatterParams,
} from 'ag-grid-community'

export const dateTimeFormatter = (
  params: ValueFormatterParams | ProcessCellForExportParams
) => {
  if (params?.value) {
    const date = new Date(params.value).toLocaleString('sv-SV')
    return date
  }
  return ''
}
